function Footer() {
  return (
    <footer>
      <div className="text-footer">
        <span>Desenvolvido por Gabriele Castro inspirado na Netflix</span>
      </div>
    </footer>
  );
}

export default Footer;
